export default {
  merchant_type_1: '个人',
  merchant_type_2: '企业',
  merchant_status_1: '有效',
  merchant_status_2: '无效',
  merchant_origin_1: '平台直签',
  merchant_origin_2: '代理商签约',
  id_num_type_1: 'National ID(Recommend)',
  id_num_type_2: 'Driver\\’s License',
  id_num_type_3: 'Passport',
  id_num_type_4: 'Postal ID',
  id_num_type_5: 'PRC (Professional ID Card)',
  id_num_type_6: 'Social Security System (SSS) ID’',
  id_num_type_7: 'UMID (Unified Multi-Purpose ID)',
  id_num_type_8: 'Voter\\’s ID',
  id_num_type_9: 'PhilHealth ID',
  id_num_type_10: 'Taxpayer Identification Number(TIN) ID',
  fee_type_1: '比例计费',
  fee_type_2: '固定金额',
  fee_structure_1: '统一费率',
  fee_structure_2: '阶梯费率',
  merchant_product_1: '收单',
  merchant_product_2: '代付',
  merchant_product_4: '退款',
  pay_trans_status_1: '未支付',
  pay_trans_status_2: '支付成功',
  pay_trans_status_3: '支付失败',
  pay_trans_status_4: '支付撤销',
  pay_trans_status_5: '支付撤销中',
  po_trans_status_0: '创建中',
  po_trans_status_1: '等待付款',
  po_trans_status_2: '付款中',
  po_trans_status_3: '付款成功',
  po_trans_status_4: '付款失败',
  po_trans_status_5: '付款中',
  po_trans_status_99: '退款完成',
  refunding_status_0: '等待退款',
  refunding_status_1: '退款中',
  refunding_status_2: '退款成功',
  refunding_status_3: '退款失败',
  refunding_status_4: '部分退款中',
  refunding_status_5: '部分退款成功',
  refunding_status_6: '退款取消',
  repayment_status_1: '支付中',
  repayment_status_2: '还款成功',
  repayment_status_3: '还款失败',
  repayment_status_4: '关闭',
  withdraw_trans_status_1: '提现中',
  withdraw_trans_status_2: '提现成功',
  withdraw_trans_status_3: '提现失败',
  withdraw_trans_status_4: '待处理',
  withdraw_trans_status_5: '待重试',
  withdraw_trans_status_6: '重试中',
  withdraw_trans_status_7: '待定价',
  withdraw_trans_status_8: '待确认',
  balance_type_1: '支付结算',
  balance_type_2: '代付',
  balance_type_3: '充值',
  balance_type_4: '提现',
  balance_type_5: '代付失败退款',
  balance_type_6: '关联商户转入',
  balance_type_7: '关联商户转出',
  balance_type_8: 'D0 收款',
  balance_type_9: '冻结金额',
  balance_type_10: '解冻金额',
  balance_type_11: '冲正',
  balance_type_12: '冲正转入',
  balance_type_13: '差错调整入金',
  balance_type_14: '差错调整出金',
  balance_type_15: '收款佣金结算',
  balance_type_16: '付款佣金结算',
  balance_type_17: '佣金扣款 (冲正)',
  balance_type_18: '佣金扣款 (代付失败退款)',
  balance_type_19: '支付后退款',
  balance_type_20: '支付退款失败',
  balance_type_21: '佣金扣款（支付退款）',
  balance_type_22: '提现失败退款',
  balance_type_23: '换汇转出',
  balance_type_24: '换汇转入',
  balance_type_25: '换汇撤销转出',
  balance_type_26: '换汇撤销转入',
  balance_type_27: 'Db收款',
  balance_type_28: 'NSDS充值',
  balance_type_29: 'NSDS服务费偿付',
  balance_type_30: 'NSDS服务费回退',
  balance_type_31: '分账转出',
  balance_type_32: '分账转入',
  balance_type_33: '分账退回-转出',
  balance_type_34: '分账退回-转入',
  balance_type_35: '提前结算手续费',
  balance_type_36: '验卡',
  balance_type_37: '验卡失败退款',
  balance_type_38: 'NSDS回收',
  balance_type_38_balance_detail: 'NSDS额度回收',
  balance_type_39: '收款凭证核验',
  balance_type_40: '收款凭证核验失败退款',
  funds_source_1: '投资',
  funds_source_2: '就业',
  funds_source_3: '商业',
  funds_source_4: '继承',
  funds_source_99: '其他',
  recharge_status_1: '充值中',
  recharge_status_2: '充值完成',
  recharge_status_3: '充值失败',
  recharge_status_4: '驳回',
  transfer_status_0: '处理中',
  transfer_status_1: '成功',
  transfer_status_2: '失败',
  transfer_record_type_1: '转出',
  transfer_record_type_2: '转入',
  upload_status_1: '上传成功',
  upload_status_2: '确认对账',
  deal_status_0: '未对账',
  deal_status_1: '未对账',
  deal_status_2: '对账中',
  deal_status_3: '对账完成',
  po_trans_type_1: '接口代付',
  po_trans_type_2: '文件批量付款',
  po_trans_type_3: '提现',
  pay_trans_type_1: '接口支付',
  pay_trans_type_2: '商户充值业务',
  ticket_status_1: '未处理',
  ticket_status_2: '处理中',
  ticket_status_3: '已处理',
  large_payment_status_1: '处理中',
  large_payment_status_2: '完成',
  large_payment_status_3: '失败',
  large_payment_status_4: '退款成功',
  institute_type_1: '支付渠道',
  institute_type_2: '代付渠道',
  institute_rate_type_1: '固定金额',
  institute_rate_type_2: '固定百分比',
  institute_rate_type_3: '单笔阶梯固定金额',
  institute_rate_type_4: '单笔阶梯固定百分比',
  institute_rate_type_5: '固定金额和百分比取小',
  institute_rate_type_6: '固定金额和百分比取大',
  action_type_1: '转出',
  action_type_2: '转入',
  channel_code_1: 'GCASH_STATIC_VA',
  channel_code_2: 'PAYMAYA_STATIC_VA',
  channel_code_3: '7ELEVEN_STATIC_VA',
  channel_code_4: 'MLH_STATIC_VA',
  channel_code_5: 'RDP_STATIC_VA',
  channel_code_6: 'QRPH_STATIC_QR',
  channel_code_7: 'QRPH_DYNAMIC_QR',
  channel_code_8: 'QRPH_HYBRID_QR',
  channel_code_9: 'INSTA_TRANSFER_ACC',
  channel_code_10: 'PESONET_TRANSFER_ACC',
  settlement_type_1: '自动结算',
  settlement_type_2: '手动结算',
  withdraw_type_1: '手动提现',
  withdraw_type_2: '自动提现',
  auto_withdraw_type_1: '提现周期',
  auto_withdraw_type_2: '提现金额',
  va_account_aduit_status_1: '审核中',
  va_account_aduit_status_2: '已通过',
  va_account_aduit_status_3: '拒绝',
  switch_status_1: '启用',
  switch_status_2: '关闭',
  mch_audit_status_1: '待审核',
  mch_audit_status_2: '驳回',
  mch_audit_status_3: '拒绝',
  mch_audit_status_4: '通过',
  read_flag_1: '未读',
  read_flag_2: '已读',
  jt_order_status_1: '待支付',
  jt_order_status_2: '已支付',
  jt_order_status_3: '已取消',
  beneficiary_audit_1: '审核中',
  beneficiary_audit_2: '通过',
  beneficiary_audit_3: '拒绝',
  beneficiary_audit_4: '驳回',
  beneficiary_audit_5: '已过期',
  single_payout_payment_type_1: '小额付款',
  single_payout_payment_type_2: '大额付款',
  transaction_settlement_status_1: '已结算',
  transaction_settlement_status_2: '待结算',
  checkout_status_1: '未支付',
  checkout_status_2: '已支付',
  checkout_status_3: '已关闭',
  fx_transaction_type_1: '换汇',
  fx_transaction_type_2: '换汇撤回',
  common_status_1: '处理中',
  common_status_2: '成功',
  common_status_3: '失败',
  beneficiary_account_type_0: 'Bank',
  beneficiary_account_type_1: 'Promptpay',
  beneficiary_account_type_2: 'E-Wallet',
  beneficiary_account_type_3: 'SBP',
  beneficiary_type_0: '证件号',
  beneficiary_type_1: '手机号',
  beneficiary_type_2: '银行账户',
  beneficiary_type_3: '银行卡号',
  loan_status_1: '待审核',
  loan_status_2: '待放款',
  loan_status_3: '已放款',
  loan_status_4: '交易拒绝',
  loan_type_1: '消费借款',
  loan_type_2: '现金借款',
  repay_method_1: '主动还款',
  repay_method_2: '代扣',
  repay_method_3: '组合还款',
  bill_status_2: '还款中',
  bill_status_3: '已还款',
  bill_status_4: '已逾期',
  loan_bill_status_1: '还款中',
  loan_bill_status_2: '已完成',
  loan_bill_status_3: '已逾期',
  credit_debit_1: '入金',
  credit_debit_2: '出金',
  benefit_address: '受益人地址',
  checkout_order_status_1: '待支付',
  checkout_order_status_2: '已支付',
  checkout_order_status_3: '已关闭',
  receiver_relation_map_1: '服务商',
  receiver_relation_map_2: '门店',
  receiver_relation_map_3: '员工',
  receiver_relation_map_4: '店主',
  receiver_relation_map_5: '合作伙伴',
  receiver_relation_map_6: '总部',
  receiver_relation_map_7: '品牌方',
  receiver_relation_map_8: '分销商',
  receiver_relation_map_9: '用户',
  receiver_relation_map_10: '供应商',
  receiver_relation_map_11: '自定义',
  receiver_type_map_1: 'PayCools 商户',
  receiver_type_map_2: '银行账号',
  receiver_type_map_3: '电子钱包',
  split_status_map_1: '待分账',
  split_status_map_2: '分账成功',
  split_status_map_3: '分账失败',
  authorization_status_1: '未授权',
  authorization_status_2: '已授权',
  card_account_status_1: '活跃',
  card_account_status_2: '未激活',
  card_account_status_3: '冻结',
  card_account_status_4: '关闭',
  card_order_status_0: '待处理',
  card_order_status_1: '处理中',
  card_order_status_2: '成功',
  card_order_status_3: '失败',
  card_name_match_result_0: '未验证',
  card_name_match_result_1: '匹配',
  card_name_match_result_2: '不匹配',
  card_account_type_1: '银行账号',
  card_account_type_2: '电子钱包',
  template_type_1: '渠道维护',
  template_type_2: '假期通知',
  template_type_3: '风险订单',
  template_type_4: '费率调整',
  template_type_5: '余额预警',
  template_type_6: '发卡争议',
  template_type_99: '其他',
  template_type_1_desc: '渠道状态变更、维护通知等',
  template_type_2_desc: '节假日通知、休息安排等',
  template_type_3_desc: '风控调单处理通知',
  template_type_4_desc: '费率调整通知',
  template_type_5_desc: '余额低于预警金额时将发送邮件。“站内通知”开关仅控制当前账号的站内通知，不影响邮件。停用预警请清空金额。',
  template_type_5_desc_sub: '预警金额由主账号配置。',
  template_type_6_desc: '争议处理相关通知',
  template_type_99_desc: '其他类型通知'
}
